import React from "react";
import { Controls, IFormStyles, useFormStyles } from "../.";

export const FormLabel: React.FC<Controls.ControlLabelProps> = (props) => {
    const styles: IFormStyles = useFormStyles();

    return (
        <Controls.ControlLabel {...props} controlStyles={styles.control} />
    );
};